import { BANK_ACCOUNTS } from "../constants/actionTypes";
import { SaveBankAccountOptionsValuesPayload } from "../types/actions";
import { DisbursementHistoryItem, GetBeneficiaryBankFieldsResponse } from "../types/api/bankAccounts";
import { CurrencyType } from "../types/api/catalog";
import { BankAccountFlowType } from "../types/forms";
import { MoneyTransferPage } from "../types/moneyTransfer";

/**
 * Action type for displaying the delete modal for a bank account
 * @param token
 */
export function ShowDeleteModal(allocationId: number | null, showModal: boolean) {
  return {
    type: BANK_ACCOUNTS.SHOW_DELETE_MODAL,
    allocationId,
    showModal
  };
}

/**
 * Action type when a bank account is successfully deleted
 * @param token
 */
export function BankAccountDeleted(payload: boolean) {
  return {
    type: BANK_ACCOUNTS.BANK_ACCOUNT_DELETED,
    payload
  };
}

/**
 * Action type to set the disbursement history for a bank account
 * @param token
 */
export function SetBankAccountDisbursementHistory(payload: { showDisbursementHistory: boolean, bankAccountName: string, bankAccountNumber: string, disbursementHistory: DisbursementHistoryItem[] }) {
  return {
    type: BANK_ACCOUNTS.SET_BANK_ACCOUNT_DISBURSEMENT_HISTORY,
    payload
  };
}

/**
 * Action type to set currencies and destination country name for a bank account
 * @param token
 */
export function SetSelectedCountry(currencies: CurrencyType[], destinationCountryName: string) {
  return {
    type: BANK_ACCOUNTS.SET_SELECTED_COUNTRY,
    currencies,
    destinationCountryName
  };
}

/**
 * Action type to set full name of currency for a bank account
 * @param token
 */
export function SetSelectedCurrency(destinationCurrencyName: string, destinationCurrencyCode: string) {
  return {
    type: BANK_ACCOUNTS.SET_SELECTED_CURRENCY,
    destinationCurrencyName,
    destinationCurrencyCode
  };
}

/**
 * Action type to update the form fields for a bank account
 * @param token
 */
export function UpdateBankAccountFormFields(pages: MoneyTransferPage[] | null) {
  return {
    type: BANK_ACCOUNTS.UPDATE_BANK_ACCOUNT_FORM_FIELDS,
    pages
  };
}

/**
 * Action type to set the data returned from banks/workflow call
 * @param token
 */
export function SetBankAccountBeneBankDetails({ result: { pages }, instructionHeader, instructionBody, nonFieldValidationErrors }: GetBeneficiaryBankFieldsResponse) {
  return {
    type: BANK_ACCOUNTS.SET_BANK_ACCOUNT_BENE_BANK_DETAILS,
    pages,
    instructionHeader,
    instructionBody,
    nonFieldValidationErrors
  };
}

/**
 * Action type to save bank account options values for a bank account to later display in ReviewAccountDetails component
 * @param payload 
 */
export function SaveBankAccountOptionsValues(payload: SaveBankAccountOptionsValuesPayload) {
  return {
    type: BANK_ACCOUNTS.SAVE_BANK_ACCOUNT_OPTIONS_VALUES,
    payload
  };
}

/**
 * Action type to save bank account options values for a bank account to later display in ReviewAccountDetails component
 * @param payload 
 */
export function UpdateBankAcccountParams(flowType: BankAccountFlowType | null, allocationId?: number | null) {
  return {
    type: BANK_ACCOUNTS.UPDATE_BANK_ACCOUNT_FLOW_TYPE,
    flowType,
    allocationId
  };
}

/**
 * Action type to reset all bank account state
 * @param payload 
 */
export function ResetBankAccountState(type?: BankAccountFlowType) {
  return {
    type: BANK_ACCOUNTS.RESET_BANK_ACCOUNT_STATE,
    flowType: type
  };
}

/**
 * Action type to reset all bank account state
 * @param payload 
 */
export function SetShowCancelModal(show: boolean) {
  return {
    type: BANK_ACCOUNTS.SET_SHOW_CANCEL_MODAL,
    payload: show
  };
}